<!--
 Copyright 2023, Avation Medical. All rights reserved.
 
 This code is proprietary and confidential information of Avation Medical. Any use, reproduction, modification
 or distribution of the code without the express prior written consent of Avation Medical is strictly prohibited.
-->

<div class="header-1">
    <button class="push-button back-button tertiary access-code-back-btn" [routerLink]="['../..']">
        <mat-icon svgIcon="back"></mat-icon>
    </button>
    <h1>Set Password</h1>
</div>
<div class="login-page">
    
    <div class="login-header">
        <img src="/assets/icons/vivally-logo.svg"/>
    </div>

    <div class="login-body">
        <div class="login-text">
            <span *ngIf="username$ | async as username">
                An access code was sent to <b>{{username | maskPhoneNumber}}</b>.<br>
                Please check your inbox (including your spam folder) and enter it below to create a new password. 
                The password must be at least 8 characters, include one number, one upper case letter, one lower case letter and one special character.
            </span>
        </div>

        <div class="login-block">
            <form class="login-form" [formGroup]="confirmPasswordForm" (ngSubmit)="submitForm()">

                <div class="form-box">
                    <mat-label style="margin-left: 1.4em;">Access Code</mat-label>
                    <mat-form-field>
                        <digit-box-input matInput formControlName="confirmationCode" count="6"></digit-box-input>
                        <mat-error><app-form-input-error [control]="confirmPasswordForm.get('confirmationCode')"></app-form-input-error></mat-error>
                    </mat-form-field>
                </div>

                <div class="form-box">
                    <mat-label>Password</mat-label>
                    <mat-form-field>
                        <input id="password" matInput placeholder="New Password" [type]="hidePassword ? 'password' : 'text'" formControlName="newPassword">
                        <mat-icon id="visibility" matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                        <mat-error><app-form-input-error [control]="confirmPasswordForm.get('newPassword')"></app-form-input-error></mat-error>
                    </mat-form-field>
                </div>

                <div class="form-box">
                    <mat-label>Confirm Password</mat-label>
                    <mat-form-field>
                        <input id="passwordConfirm" matInput placeholder="Confirm New Password" [type]="hidePassword ? 'password' : 'text'" formControlName="passwordConfirm">
                        <mat-icon id="visibilityConfirm" matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ? 'visibility' : 'visibility_off'}}</mat-icon>
                        <mat-error><app-form-input-error [control]="confirmPasswordForm.get('passwordConfirm')"></app-form-input-error></mat-error>
                    </mat-form-field>
                </div>
                <!-- <div class="">Already a user ? <a class="forgot-password" [routerLink]="['..']">Login</a></div> -->
                <div class="error-text">
                    <div id="errorStr" *ngIf="errorStr">{{this.errorStr}}</div>       
                </div>
                <br>
                <span style="color: #1F4C7C;">Contact Avation Medical for any help.</span>
                <div style="margin-top: 2em;" class="login-block" *ngIf="!loading; else while_loading">
                    <div>
                        <button class="push-button tertiary" type="button" style="margin-right: 0.8em;" [routerLink]="['../..']">Back</button>
                        <button id="setPassword" class="push-button primary" type="submit">Set Password</button>
                    </div>
                </div>
                <ng-template #while_loading>
                    <mat-progress-spinner class="progress-spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
                </ng-template>
            </form>
        </div>
    </div>
    <vivally-footer></vivally-footer>
</div>
